// Pages that exist only on the Traditional Chinese site. 注音符號表 (D-195): zhuyin is taught in Taiwan, so /tools/zhuyin has no
// other language version; every other locale's marketing JSON leaves it out and /en/tools/zhuyin and the like are unindexed 404s.
// Kept apart from marketing-pages.ts so the language switcher can ask without loading every locale's page list.
import { isLightLocale, type Locale } from "./i18n/locales";
import { LIGHT_TOOL_SLUGS } from "./light-tools";

export const TRADITIONAL_ONLY_TOOLS: ReadonlySet<string> = new Set(["zhuyin", "zhuyin-text"]); // zhuyin-text: 文章加注音 (D-203)

/** Whether a base path (no locale prefix) has a version in `target`. */
export const pathExistsIn = (basePath: string, target: Locale) => {
  const tool = /^\/tools\/([^/]+)$/.exec(basePath)?.[1];
  // A light language (D-231) has the tools index and its own tool list, nothing else.
  if (isLightLocale(target)) return basePath === "/tools" || (!!tool && LIGHT_TOOL_SLUGS[target].has(tool));
  return target === "zh-Hant" || !tool || !TRADITIONAL_ONLY_TOOLS.has(tool);
};
